import { InputNumber } from "antd"
import style from "./PriceSection.module.scss"

const { section, labelRow, label, requiredMark, numberInput } = style

type Props = {
	value: number | null
	onChange: (value: number | null) => void
	onBlur?: () => void
}

export const PriceSection = ({ value, onChange, onBlur }: Props) => {
	return (
		<div className={section}>
			<div className={labelRow}>
				<span className={label}>Price</span>
				<span className={requiredMark}>*</span>
			</div>
			<InputNumber
				className={numberInput}
				value={value}
				onChange={(v) => onChange(typeof v === "number" ? v : null)}
				onBlur={onBlur}
				prefix="$"
				controls={false}
				min={0}
			/>
		</div>
	)
}
